import { createContext } from 'react';

const TaskModalContext = createContext();

export default TaskModalContext;
